import React from "react"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

const Badge = ({ data = {}, refSymbol = "*" }) => {
  const {
    lineOne = `#1 Dermatologist-Recommended`,
    lineTwo = `Hair Growth Supplement Brand`,
    classes = `text-center`,
    lineOneClass = `Body-20-Dia-Strong text-nova-base-black mb-[2px]`,
    lineTwoClass = `Body-20-Dia-Normal text-nova-transparency-black-60`,
  } = data
  return (
    <div className={classes}>
      <TextElementNova text={lineOne} element="p" className={lineOneClass} />
      <TextElementNova
        text={lineTwo + refSymbol}
        element="p"
        className={lineTwoClass}
      />
    </div>
  )
}

export default Badge
